/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import classNames from "classnames";

const UsersListIcon = ({ isActive, className }) => {
  let fill;
  if (isActive === false) {
    fill = "#9a9a9a";
  } else {
    fill = "white";
  }

  return (
    <svg
      width="20"
      height="20"
      className={classNames(className)}
      viewBox="0 0 24 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      test-id="vN4ulMpo"
    >
      <path
        d="M12 7.46387C13.63 7.46387 15.07 7.85387 16.24 8.36387C17.32 8.84387 18 9.92387 18 11.0939V12.7139H6V11.1039C6 9.92387 6.68 8.84387 7.76 8.37387C8.93 7.85387 10.37 7.46387 12 7.46387ZM4 7.71387C5.1 7.71387 6 6.81387 6 5.71387C6 4.61387 5.1 3.71387 4 3.71387C2.9 3.71387 2 4.61387 2 5.71387C2 6.81387 2.9 7.71387 4 7.71387ZM5.13 8.81387C4.76 8.75387 4.39 8.71387 4 8.71387C3.01 8.71387 2.07 8.92387 1.22 9.29387C0.48 9.61387 0 10.3339 0 11.1439V12.7139H4.5V11.1039C4.5 10.2739 4.73 9.49387 5.13 8.81387ZM20 7.71387C21.1 7.71387 22 6.81387 22 5.71387C22 4.61387 21.1 3.71387 20 3.71387C18.9 3.71387 18 4.61387 18 5.71387C18 6.81387 18.9 7.71387 20 7.71387ZM24 11.1439C24 10.3339 23.52 9.61387 22.78 9.29387C21.93 8.92387 20.99 8.71387 20 8.71387C19.61 8.71387 19.24 8.75387 18.87 8.81387C19.27 9.49387 19.5 10.2739 19.5 11.1039V12.7139H24V11.1439ZM12 0.713867C13.66 0.713867 15 2.05387 15 3.71387C15 5.37387 13.66 6.71387 12 6.71387C10.34 6.71387 9 5.37387 9 3.71387C9 2.05387 10.34 0.713867 12 0.713867Z"
        fill={fill}
        test-id="mYAgA1wx"
      />
    </svg>
  );
};

export default UsersListIcon;
